import { render, staticRenderFns } from "./CardSectionsBlockFooter.vue?vue&type=template&id=5a694047"
import script from "./CardSectionsBlockFooter.vue?vue&type=script&lang=js"
export * from "./CardSectionsBlockFooter.vue?vue&type=script&lang=js"
import style0 from "./CardSectionsBlockFooter.vue?vue&type=style&index=0&id=5a694047&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports